import { splitCamelCaseToString } from 'data/helpers'
import { YEARS_EXPERIENCE_ENUM } from 'data/enums'

export const formatYearsExperience = yearsExperience => {
  return YEARS_EXPERIENCE_ENUM[yearsExperience] || null
}

export const formatBoardEligibility = boardEligibility => {
  return boardEligibility ? splitCamelCaseToString(boardEligibility) : null
}

export const formatSearchStatus = searchStatus => {
  return searchStatus ? splitCamelCaseToString(searchStatus) : null
}

export const formatAvailabilityDate = availabilityDate => {
  if (!availabilityDate) return null
  return new Date(availabilityDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export const formatSpecialties = specialties => {
  if (!Array.isArray(specialties) || specialties.length === 0) return null
  return specialties.map(s => s.name).join(', ')
}

export const formatLanguages = candidateLanguages => {
  if (!Array.isArray(candidateLanguages) || candidateLanguages.length === 0) return null
  return candidateLanguages.map(lang => `${lang.language} (${lang.proficiency})`).join(', ')
}

export const formatVisas = visas => {
  if (!Array.isArray(visas) || visas.length === 0) return null
  return visas.map(visa => visa.name).join(', ')
}

export const formatPreferredStates = preferredStates => {
  if (!Array.isArray(preferredStates) || preferredStates.length === 0) return null
  return preferredStates.join(', ')
}

export const formatRelocationPreference = relocationPreference => {
  return relocationPreference ? splitCamelCaseToString(relocationPreference) : null
}

export const formatPracticeTypes = preferredPracticeTypes => {
  if (!Array.isArray(preferredPracticeTypes) || preferredPracticeTypes.length === 0) return null
  return preferredPracticeTypes.join(', ')
}

export const formatAreaTypes = preferredAreaTypes => {
  if (!Array.isArray(preferredAreaTypes) || preferredAreaTypes.length === 0) return null
  return preferredAreaTypes.join(', ')
}

export const formatAcademicPreference = academicPreference => {
  return academicPreference ? splitCamelCaseToString(academicPreference) : null
}

export const formatGlobalRegions = preferredGlobalRegions => {
  if (!Array.isArray(preferredGlobalRegions) || preferredGlobalRegions.length === 0) return null
  return preferredGlobalRegions.join(', ')
}

export const formatLicensedStates = licensedStates => {
  if (!Array.isArray(licensedStates) || licensedStates.length === 0) return null
  return licensedStates.join(', ')
}

export const formatMemberDate = date => {
  if (!date) return null
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
  })
}

export const getSearchStatusColor = searchStatus => {
  switch (searchStatus) {
    case 'ActivelyLooking':
      return 'success'
    case 'PassivelyLooking':
      return 'teal'
    case 'NotLooking':
      return 'error'
    default:
      return 'default'
  }
}
